import { Switch } from '@headlessui/react'
import React, { useEffect, useState } from 'react'

type Props = {
  id: any
  value: boolean,
  onChange: any,
  disabled: boolean,
}

const SwitchButton = (props: Props) => {
  const { id, value, onChange, disabled = false } = props
  

  return (
    <>
      <Switch
        checked={value}
        onChange={(e: any) => onChange(e, id)}
        disabled={disabled}
        className={`${value ? 'bg-[#68D391]' : 'bg-gray-300'}
          relative inline-flex h-5 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${value ? 'translate-x-3' : 'translate-x-0'}
            pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </>
  )
}

export default SwitchButton